import React, { Fragment } from "react";

export default (
  <>
    <path d="M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 1.333A10.657 10.657 0 0122.667 12 10.657 10.657 0 0112 22.667 10.657 10.657 0 011.333 12 10.657 10.657 0 0112 1.333z" />
    <path d="M10.702 4.738a1.482 1.482 0 00-.035.273c.035.58.537 9.07.583 9.656h1.417c.046-.587.631-9.07.666-9.656a1.001 1.001 0 00-.035-.303.716.716 0 00-.188-.334 1.034 1.034 0 00-.42-.263c-.177-.074-.417-.111-.72-.111s-.543.04-.72.121a.927.927 0 00-.386.283.782.782 0 00-.162.334zM13.333 18.667a1.333 1.333 0 11-2.666 0 1.333 1.333 0 012.666 0z" />
  </>
);
